import Queue from "nq-js";

class UpdateSchemaUseCase {
  execute(schema) {
    return new Queue.Schema().update(schema);
  }
}

export default UpdateSchemaUseCase;
